import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

const DatasetNameSchema = z.string().min(1).max(255);
const DatasetDescriptionSchema = z.string().max(10000).nullable();

export const DatasetSchema = z.object({
  datasetId: PrimaryKeySchema,
  teamId: PrimaryKeySchema,
  name: DatasetNameSchema,
  description: DatasetDescriptionSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Dataset = z.infer<typeof DatasetSchema>;

export const DatasetsSchema = z.array(DatasetSchema);

export type Datasets = z.infer<typeof DatasetsSchema>;

export const DatasetsQuerySchema = z
  .object({
    datasetIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    teamIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    nameLike: z.string().optional(),
    name: z.string().optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(
      z.enum(['createdAt', 'updatedAt', 'name']),
    ),
  );

export type DatasetsQuery = z.infer<typeof DatasetsQuerySchema>;

export const CreateDatasetRequestSchema = z.object({
  teamId: PrimaryKeySchema,
  name: DatasetNameSchema,
  description: DatasetDescriptionSchema.optional(),
});

export type CreateDatasetRequest = z.infer<typeof CreateDatasetRequestSchema>;

export const UpdateDatasetRequestSchema = DatasetSchema.pick({
  name: true,
  description: true,
}).partial();

export type UpdateDatasetRequest = z.infer<typeof UpdateDatasetRequestSchema>;
